import { type ApiInvoice } from '@Model';
import { Card, type IGuiBinder, TextInput, useProp, useTranslate } from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-09-18T07:55:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5

interface IProps {
    binder: IGuiBinder<ApiInvoice>;
}

export const InvoiceRemarksSection = memo(function InvoiceRemarksSection({ binder }: IProps) {
    const i18n = useTranslate('');
    const remarksField = useProp(binder, 'remarks');

    return (
        <Card name="remarks" label={i18n('Bemerkung')}>
            <TextInput {...remarksField} inputSize={3} label="" />
        </Card>
    );
});
